import { File, Info, Pen, Phone, Sparkles } from 'lucide-react';
import type { TRoute } from './types';

export const ROUTES: Array<TRoute> = [
  { path: '/', title: 'Home' },
  { path: '/product', title: 'Product' },
  {
    path: '/company',
    title: 'Company',
    nested: [
      {
        path: '/about',
        title: 'About us',
        description: 'Learn more about Codesi',
        icon: <Info size={18} />,
      },
      {
        title: 'Contact us',
        path: '/contact-us',
        description: 'Contact information',
        icon: <Phone size={18} />,
      },
      {
        path: '/blog',
        title: 'Blog',
        description: 'The latest posts and changes',
        icon: <Pen size={18} />,
      },
      {
        path: '/terms',
        title: 'Terms & conditions',
        description: 'Learn more about terms',
        icon: <File size={18} />,
      },
      {
        title: 'Request a feature',
        path: 'https://codesi.featurebase.app/en',
        description: 'Suggest a feature',
        icon: <Sparkles size={18} />,
        target: '_blank',
      },
    ],
  },
  { path: '/pricing', title: 'Pricing' },
];
